// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            address: yup.string().nullable(),
            googleMapsLink: yup.string().nullable(),
            landmarks: yup.string().nullable(),
            town: yup.string().nullable(),
            latitude: yup
                .number()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-latitude-invalid' }))
                .min(-90, intl.formatMessage({ id: 'ui-comp-formvalidation-latitude-range' }))
                .max(90, intl.formatMessage({ id: 'ui-comp-formvalidation-latitude-range' }))
                .nullable(),
            longitude: yup
                .number()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-longitude-invalid' }))
                .min(-180, intl.formatMessage({ id: 'ui-comp-formvalidation-longitude-range' }))
                .max(180, intl.formatMessage({ id: 'ui-comp-formvalidation-longitude-range' }))
                .nullable(),
            province: yup.object().shape({}).nullable(),
            municipality: yup.object().shape({}).nullable()
        })
        // .test({
        //     name: 'checkAtLeastOneFieldIsFilled',
        //     message: intl.formatMessage({ id: 'ui-comp-formvalidation-location-fields-atleastone' }),
        //     test: (location) =>
        //         ('address' in (location || {}) && location.address?.length > 0) ||
        //         ('landmarks' in (location || {}) && location.landmarks?.length > 0) ||
        //         ('town' in (location || {}) && location.town?.length > 0) ||
        //         ('latitude' in (location || {}) && location.latitude !== null) ||
        //         ('longitude' in (location || {}) && location.longitude !== null)
        // })
        .nullable();

export default validationSchema;
